// Whether the Edit Account form has any change compared with the saved
// account. Every submitted field is compared generally (numbers by value,
// yes/no fields as booleans, text trimmed), so Update with nothing changed
// can say so instead of saving the same values again.
const IGNORED = new Set(['opening_balance', 'opening_balance_date']);

function norm(v) {
  if (v === null || v === undefined) return '';
  if (typeof v === 'boolean') return v ? 'true' : 'false';
  const s = String(v).trim();
  if (s === 'on') return 'true';
  if (s !== '' && Number.isFinite(Number(s))) return String(Number(s));
  return s;
}

export function accountFormChanged(data, account) {
  if (!account) return true;
  return Object.keys(data || {}).some((k) => {
    if (IGNORED.has(k)) return false;
    if (!(k in account)) return norm(data[k]) !== '' && norm(data[k]) !== 'false';
    return norm(data[k]) !== norm(account[k]);
  });
}

export const NO_CHANGES = 'No changes to save.';
